import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Button from '4all-ui/components/Button';
import Checkbox from '4all-ui/components/Checkbox';
import * as styles from './style';
import withCategories from '../../../../containers/Categories';
import FormLoader from '../../../../components/FormLoader';
import ArrowIcon from '../../../../components/Icons/ArrowIcon';
import { PRODUCT_CORE_ACTIONS } from '../../../../helpers/constants';

class Header extends PureComponent {
  state = {
    categoryName: this.props.name,
    categoryNameDefault: this.props.name,
    showModal: false,
  };

  onChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  onClose = () => {
    this.setState({ showModal: false });
  };

  onKeyDownEditName = e => {
    if (e.keyCode === 27) {
      this.stopEditName();
    }
  };

  onBlur = e => {
    this.updateCategory(e);
  };

  stopEditName = () => {
    const { categoryNameDefault } = this.state;

    this.setState({ categoryName: categoryNameDefault });
  };

  updateCategory = async e => {
    e.preventDefault();

    const { categoryName, categoryNameDefault } = this.state;
    const { id, productCategories, updateProductCategoryName, editCategory } = this.props;

    if (categoryName.length === 0 || categoryName === categoryNameDefault) {
      this.stopEditName();
      return;
    }

    this.setState({ showModal: true });
    await editCategory(id, { name: categoryName });

    if (productCategories.error) {
      this.setState({ categoryName: categoryNameDefault });
    } else {
      updateProductCategoryName(id, categoryName);
    }
  };

  deleteCategory = e => {
    const { onClickProductActions, id } = this.props;

    e.stopPropagation();
    onClickProductActions(PRODUCT_CORE_ACTIONS.DELETE, {
      categories: [id],
    });
  };

  render() {
    const {
      id,
      name,
      check,
      isOpen,
      productCategories,
      numberOfProducts,
      isDragDisabled,
      isDragging,
      toggleListCategoryItem,
      isCheckDisabled,
    } = this.props;
    const { showModal, categoryName } = this.state;
    const isDisabled = numberOfProducts === 0;

    return (
      <styles.CategoryHeader
        id={`category_header_${id}`}
        isOpen={isOpen}
        disabled={isDisabled}
        isDragDisabled={isDragDisabled}
        isDragging={isDragging}
      >
        <FormLoader
          onClose={this.onClose}
          isSubmiting={productCategories.isLoadingSubmit}
          showModal={showModal}
          error={productCategories.error || {}}
          finishedText="Categoria atualizada com sucesso!"
          loadingText="Salvando Categoria ..."
        />

        <styles.CategoryTitleContainer isDragging={isDragging}>
          <styles.CheckboxContainer onClick={e => e.stopPropagation()} role="button">
            <Checkbox
              id={`checkbox_${id}`}
              name={name}
              onChange={() => toggleListCategoryItem(id)}
              checked={check}
              disabled={isCheckDisabled}
            />
          </styles.CheckboxContainer>
          <form onSubmit={this.updateCategory}>
            <styles.Input
              type="text"
              name="categoryName"
              id={`categoryName_input_${id}`}
              value={categoryName}
              onChange={this.onChange}
              onBlur={showModal ? () => {} : this.onBlur}
              onKeyDown={this.onKeyDownEditName}
              onClick={e => e.stopPropagation()}
              onKeyPress={e => e.stopPropagation()}
              disabled={isDragging}
              style={{
                width: (categoryName.length + 1) * 20,
              }}
            />
          </form>
        </styles.CategoryTitleContainer>

        <styles.CategoryActions isDragging={isDragging}>
          <Button link onClick={this.deleteCategory} id={`btn-remove-category-${id}`}>
            Excluir
          </Button>
          <ArrowIcon
            id={`category-arrow-icon-${id}`}
            absolute={false}
            isOpen={isOpen}
            disabled={isDisabled}
            size="30px"
          />
        </styles.CategoryActions>
      </styles.CategoryHeader>
    );
  }
}

Header.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  check: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  numberOfProducts: PropTypes.number.isRequired,
  productCategories: PropTypes.object.isRequired,
  updateProductCategoryName: PropTypes.func.isRequired,
  isDragDisabled: PropTypes.bool.isRequired,
  isDragging: PropTypes.bool.isRequired,
  toggleListCategoryItem: PropTypes.func.isRequired,
  editCategory: PropTypes.func.isRequired,
  onClickProductActions: PropTypes.func.isRequired,
};

export default withCategories(Header);



// WEBPACK FOOTER //
// ./src/screens/Product/Categories/Header/index.js